exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".teacherFooterComponent---3g29e {\n  position: fixed;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  min-height: 80px;\n  padding: 20px;\n  background-color: #adb6bc; }\n\n.buttonContainer---2nlEk {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-pack: end;\n  -ms-flex-pack: end;\n  -moz-justify-content: flex-end;\n  justify-content: flex-end;\n  -webkit-box-flex: 1;\n  -moz-flex: 1;\n  -ms-flex: 1;\n  flex: 1; }\n\n.footerButton---XCVCF, .bulkPasswordChange---2gLT8,\n.deleteTeachers---2HdCb,\n.unassign---39Y-J {\n  margin-left: 10px; }\n\n.svgIconContainer---2q-sW {\n  width: 1px;\n  height: 25px;\n  margin: 7px; }\n\n.svgIconContainer---2q-sW svg path {\n    fill: none !important; }\n\n.iconClassName---sNxLZ {\n  height: 40px;\n  width: 1px; }\n\n.iconClassName---sNxLZ path {\n    fill: none !important; }\n\n.highlight---1WYfw {\n  color: #32a8a7; }\n", ""]);

// exports
exports.locals = {
	"teacherFooterComponent": "teacherFooterComponent---3g29e",
	"buttonContainer": "buttonContainer---2nlEk",
	"footerButton": "footerButton---XCVCF",
	"bulkPasswordChange": "bulkPasswordChange---2gLT8",
	"deleteTeachers": "deleteTeachers---2HdCb",
	"unassign": "unassign---39Y-J",
	"svgIconContainer": "svgIconContainer---2q-sW",
	"iconClassName": "iconClassName---sNxLZ",
	"highlight": "highlight---1WYfw"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader/lib!./~/sass-loader!./app/components/teacher-footer/index.scss
// module id = 1206
// module chunks = 3